export default __webpack_public_path__ + "static/media/HIW-lol-2.c1badea0.webp";